type EventHandler<T = any> = (payload: T) => void;

class EventBus {
  private handlers: Map<string, Set<EventHandler>> = new Map();

  on<T = any>(event: string, handler: EventHandler<T>): () => void {
    const set = this.handlers.get(event) ?? new Set<EventHandler>();
    set.add(handler as EventHandler);
    this.handlers.set(event, set);
    return () => this.off(event, handler);
  }

  off<T = any>(event: string, handler: EventHandler<T>): void {
    const set = this.handlers.get(event);
    if (!set) return;
    set.delete(handler as EventHandler);
    if (set.size === 0) this.handlers.delete(event);
  }

  emit<T = any>(event: string, payload: T): void {
    const set = this.handlers.get(event);
    if (!set) return;
    Array.from(set).forEach(handler => {
      try {
        handler(payload);
      } catch {}
    });
  }
}

export const eventBus = new EventBus();

// Messaging-specific event types
export interface MessagingNewMessageEvent {
  conversation_id: string;
  message: any;
}


